<script setup lang="ts">
import {onMounted} from "vue";

import { defineAsyncComponent } from 'vue';

const Default = defineAsyncComponent(() => import('@/views/layouts/Default.vue'));

onMounted(() => {
    document.querySelector('link[rel="canonical"]')?.setAttribute('href', document.location.href);
  if (typeof window !== 'undefined') {
    window.scrollTo(0, 0)
  }
})
</script>

<template>
<Default>
        <!-- BEGIN: Content-->
        <div class="app-content content pt-5"
            style="min-height:75%; margin-left: 0px; margin-top: 6rem; background-color: white;">
            <main id="main">
                <!-- ======= Breadcrumbs ======= -->
                <section id="breadcrumbs" class="breadcrumbs mb-4">
                    <div class="container">
                        <div class="h1 h-style-with-color h1-style use-poppins">Mentions légales</div>
                    </div>
                </section><!-- End Breadcrumbs -->

                <section class="py-0 about p-0 mb-0" >
                    <div class="container mb-0">
                        <div class="row mb-0">
                            <div class="col-12 icon-boxes d-flex flex-column align-items-stretch justify-content-center ">
                                <div>
                                    <div class="h3 h-style h3-style use-poppins mb-3"> Edition de la plateforme topela </div>
                                    <p>
                                        Le site <a href="https://123topela.fr" target="_blanc" style="text-decoration: underline !important;color:#0070C0 !important;">123topela.fr</a> et l’application mobile topela 
                                        (ci-après désignés ensemble, la <strong>« Plateforme »</strong>) sont édités par la société Webck, Société par actions simplifiée au capital de 25 000 €, 
                                        immatriculée au RCS de Nanterre sous le n°904 029 014, dont le siège social est situé 6 avenue Edouard Herriot, 92350 LE PLESSIS-ROBINSON (ci-après l’ « Editeur »).
                                    </p>
                                    <p>
                                        L’Editeur peut être contacté à l’adresse email <span style="text-decoration: underline;color:#0070C0">admin@webck.fr</span> ou au numéro 06 61 55 37 29.
                                    </p>
                                    <p>
                                        Le numéro de TVA Intercommunautaire de l’Editeur est le : FR34904029014.
                                    </p>
                                
                                </div>
                                <div>
                                    <div class="h3 h-style h3-style use-poppins mb-3">Hébergeur de la plateforme topela</div>
                                    <p>
                                        La Plateforme topela est hébergée par la société Amazon Web Services EMEA SARL, Société étrangère immatriculée au RCS de Nanterre sous le n°831 001 334, 
                                        dont le siège social est situé 38, avenue John F. Kennedy L 1855 99137 Luxembourg.
                                    </p>
                                    <p>
                                        L’hébergeur est joignable via la page suivante : <a target="_blanc" style="text-decoration: underline !important;color:#0070C0 !important;" href="https://aws.amazon.com/fr/contact-us/">https://aws.amazon.com/fr/contact-us/</a>.
                                    </p>
                                </div>
                                <div>
                                    <div class="h3 h-style h3-style use-poppins mb-3">Respect de la propriété intellectuelle</div>
                                    <p>
                                        Toutes les marques, photographies, textes, commentaires, illustrations, images animées ou non, séquences vidéo, sons, ainsi que toutes les applications informatiques qui pourraient être utilisées pour faire fonctionner 
                                        la Plateforme topela et plus généralement tous les éléments reproduits ou utilisés sur la Plateforme topela sont protégés par les lois en vigueur au titre de la propriété intellectuelle.
                                    </p>
                                    <p>
                                        Ils sont la propriété pleine et entière de l'Éditeur ou de ses partenaires, sauf mentions particulières. 
                                    </p>
                                    <p>
                                        Toute reproduction, représentation, utilisation ou adaptation, sous quelque forme que ce soit, de tout ou partie de ces éléments, y compris les applications informatiques, sans l'accord préalable et écrit de l'Éditeur, sont strictement interdites. 
                                        Le fait pour l'Éditeur de ne pas engager de procédure dès la prise de connaissance de ces utilisations non autorisées ne vaut pas acceptation desdites utilisations et renonciation aux poursuites.
                                    </p>
                                    <p>
                                        Seule l'utilisation pour un usage privé dans un cercle de famille est autorisée et toute autre utilisation est constitutive de contrefaçon et/ou d'atteinte aux droits voisins, sanctionnées par Code de la propriété intellectuelle. 
                                        La reprise de tout ou partie de ce contenu nécessite l'autorisation préalable de l'Éditeur ou du titulaire des droits sur ce contenu.
                                    </p>
                                </div>
                                <div class="mb-3">
                                    <div class="h3 h-style h3-style use-poppins mb-3">Liens hypertextes</div>
                                    <p>
                                        La Plateforme topela peut contenir des liens hypertexte donnant accès à d'autres sites web édités et gérés par des tiers et non par l'Éditeur. 
                                        L'Éditeur ne pourra être tenu responsable directement ou indirectement dans le cas où lesdits sites tiers ne respecteraient pas les dispositions légales. 
                                    </p>
                                    <p>
                                        La création de liens hypertexte vers la Plateforme topela ne peut être faite qu'avec l'autorisation écrite et préalable de l'Éditeur.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mb-5"></div>
                </section>
        </main>
    </div>
</Default>
</template>

<style scoped>
body {
    font-family: "Century Gothic", sans-serif;
    color: #233648;
}

p {
    color: rgb(75, 75, 75);
    margin-top: 0;
    margin-bottom: 0.5rem !important;
}

ul li {
    list-style: disc;
}

h3, .h3 {
    font-size: 20px !important;
    margin-bottom: 0.5rem !important;
    margin-top:15px !important;
}

.h3{
    font-weight: bold;
}
</style>